import React, { useState } from "react";
import css from "../Tracker.css";
import Card from "react-bootstrap/Card";
import CardHeader from "./CardHeader";
import CardBody from "./CardBody";

const TimerCard = ({
    item,
    resumeTimeTracking,
    timeFormat,
    resumeLoading,
    customeTime,
    selectedUser,
    globalEditedId,
    setGlobalEditedId,
    refetchTimerData,
}) => {
    return (
        <Card className="text-center card-bg">
            <CardHeader item={item} />
            <CardBody
                item={item}
                resumeTimeTracking={resumeTimeTracking}
                resumeLoading={resumeLoading}
                customeTime={customeTime}
                timeFormat={timeFormat}
                selectedUser={selectedUser}
                globalEditedId={globalEditedId}
                setGlobalEditedId={setGlobalEditedId}
                refetchTimerData={refetchTimerData}
            />
        </Card>
    );
}
export default React.memo(TimerCard);